<template>
	<el-container class="social-assitance" style="padding: 10px">
		<left-menu  :width="'220px'"></left-menu>
		<div class="contentBox" :style="{height: clientHeight}">
			<keep-alive>
                <router-view></router-view>
            </keep-alive>
		</div>
	</el-container>
</template>
<script>
	import leftMenu from '@/components/leftMenu/left-menu'
	export default {
		name: "social-assitance",
		components:{leftMenu},
		data() {
			return {
				clientHeight: '',
				activeTab: 'social'
			}
		},
		created() {
			this.clientHeight = (document.body.clientHeight - 120) + 'px';
		},
	}
</script>

<style lang="less" scoped>
	.social-assitance {
		display: flex;

		.tab-box {
			width: 220px;
			background: #fff;
			box-sizing: border-box;
			padding: 10px 5px;

			.tab {
				display: flex;
				justify-content: space-around;
				align-items: center;
				border-radius: 5px;
				background-color: #409EFF;
				color: #ccc;
				padding: 10px;
				margin-bottom: 20px;

				.item {
					cursor: pointer;

					&:hover {
						color: #fff;

					}
				}

				.active {
					color: #fff;
				}

				.tab-line {
					width: 1px;
					height: 16px;
					background: #83bffc;
				}
			}

			.tab-content {
				div {
					padding: 10px;
					background: #409EFF;
					color: #fff;
					display: flex;
					justify-content: center;
				}
			}
		}

		.contentBox {
			// flex: 1;
			width: calc(100vw - 240px);
			height: 100%;
		}
	}
</style>
